// extracted by mini-css-extract-plugin
export default {"divider":"login_divider__hikK8","loginImage":"login_loginImage__m8mP2"};